module.exports = __webpack_public_path__ + "static/media/miss-america.29069031.png";